import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {parseErrorResponse, showAlert} from "../../../helpers/helper_functions";
import {GET_REQUEST} from "../../../values/globals";
import endpoints from "../../../routes/endpoints";
import {makeRequest} from "../../../helpers/network_utils";

class Totals extends React.Component {
    state = {
        loading: false,
        statistics: {}
    }

    componentDidMount() {
        this.getStatistics();
    }

    getStatistics = () => {
        this.setState({
            loading: true
        })
        makeRequest(GET_REQUEST, endpoints.stats, {}, response => {
            this.setState({
                statistics: response.data
            })
        }, error => {
            showAlert('error', 'Error', parseErrorResponse(error))
        }, () => {
            this.setState({
                loading: false
            })
        })
    }

    render() {
        const {loading, statistics} = this.state;
        return (
            loading ?
                <div className="text-center">
                    <CircularProgress/>
                </div> :
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card mb-4 bg-purple">
                                <div className="card-body">
                                    <div className="media d-flex align-items-center ">
                                        <div className="mr-4 rounded-circle bg-white sr-icon-box text-purple">
                                            <span style={{fontSize: "2rem"}} className="icon-people"/>
                                        </div>
                                        <div className="media-body text-light">
                                            <h4 className="text-uppercase mb-0 weight500">{statistics?.total_students ?? "-"}</h4>
                                            <span>Total Students In Center</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card mb-4 bg-primary">
                                <div className="card-body">
                                    <div className="media d-flex align-items-center">
                                        <div className="mr-4 rounded-circle bg-white  sr-icon-box text-primary">
                                            <span style={{fontSize: "1.5rem"}} className="icon-people"/>
                                        </div>
                                        <div className="media-body text-white">
                                            <h4 className="text-uppercase mb-0 weight500">{statistics?.total_lecs ?? "-"}</h4>
                                            <span>Total Lecturers In Center</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Totals;